<template>
  <button
    @click="toggleTheme"
    class="relative inline-flex items-center justify-center w-10 h-10 rounded-full transition-colors
           text-ink-500 hover:bg-ink-100 dark:text-ink-400 dark:hover:bg-ink-800 focus:outline-none"
    :title="isDark ? 'Passer en mode clair' : 'Passer en mode sombre'"
  >
    <i class="fa-solid fa-sun text-lg transition-transform duration-300 rotate-0 scale-100 dark:-rotate-90 dark:scale-0"></i>
    
    <i class="absolute fa-solid fa-moon text-lg transition-transform duration-300 rotate-90 scale-0 dark:rotate-0 dark:scale-100"></i>
  </button>
</template>

<script>
export default {
  name: 'ThemeToggle',
  data() {
    return {
      isDark: false
    }
  },
  mounted() {
    // Synchroniser l'état du bouton avec la réalité au chargement
    this.isDark = document.documentElement.classList.contains('dark');
  },
  methods: {
    toggleTheme() {
      // Inverser l'état
      this.isDark = !this.isDark;
      
      if (this.isDark) {
        document.documentElement.classList.add('dark');
        localStorage.theme = 'dark';
      } else {
        document.documentElement.classList.remove('dark');
        localStorage.theme = 'light';
      }
    }
  }
}
</script>